import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { EssenceBalance } from '#src/components/balance/EssenceBalance/index.tsx';
import { GemsBalance } from '#src/components/commonGame/GemsBalance/index.tsx';
import { ANY_SPORT_SERIES_MARKET } from '#src/constants/__generated__/routes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { getCommonCardShardsCount } from '#src/lib/currentUser/index.tsx';
import { useCommonGameSet } from '#src/set/index.ts';

export const MobileSeriesUserCurrencies = () => {
  const commonGameSet = useCommonGameSet();
  const activeCardSetSlug = commonGameSet.slug;
  const { generateSportContextPath } = useSportContext();
  const { currentUser } = useCurrentUserContext();

  const shardsBalance = getCommonCardShardsCount(
    currentUser,
    activeCardSetSlug
  );

  const showGems = !currentUser?.anyUserSportProfile?.proUnlocked;

  return (
    <Horizontal>
      {!!showGems && (
        <GemsBalance
          balance={currentUser?.gemsBalances[0]?.amount || 0}
          variant="vertical"
        />
      )}
      <EssenceBalance
        variant="vertical"
        value={shardsBalance || 0}
        rarity={Rarity.common}
        cardSetSlug={activeCardSetSlug}
        to={generateSportContextPath(ANY_SPORT_SERIES_MARKET)}
      />
    </Horizontal>
  );
};
